import { render, staticRenderFns } from "./FooterSlot.vue?vue&type=template&id=f587d264"
import script from "./FooterSlot.vue?vue&type=script&lang=js"
export * from "./FooterSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports